module.exports = __webpack_public_path__ + "static/SVHome-05-fe12c633f996dcc63434023073eb1a84.png";